import React, { useEffect, useState } from 'react'
import IconButton from '@mui/material/IconButton'
import { Container, ModalContent, BookingsHeader } from './styled'
import { useTranslation } from 'react-i18next'
import { getBookings } from 'api'
import { Grid, Box, TextField, MenuItem, Button, Modal, Drawer, useTheme, useMediaQuery } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router'
import FilterListIcon from '@mui/icons-material/FilterList'
import CloseIcon from '@mui/icons-material/Close'
import BookingDetail from 'components/pages/booking/bookingDetail/view';
import BookingList from 'components/organisms/bookingList/view';
import EventNoteIcon from '@mui/icons-material/EventNote';

const BookingHome = () => {

  const { t } = useTranslation()
  const [bookings, setBookings] = useState([])
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    status: 'AL',
    venue: '',
    code: '',
    date: '',
    order_by: 'planned_start_day',
    order_dir: 'desc',
    page_size: 10,
    page_number: 1
  });

  const statusMapping = {
    AL: 'All',
    AC: 'Confirmed',
    PC: 'Pending Confirmation',
    CA: 'Cancelled',
    FN: 'Finished',
    RJ: 'Rejected'
  };

  const statusOptions = [
    { value: 'AL', label: 'All' },
    { value: 'AC', label: 'Confirmed' },
    { value: 'PC', label: 'Pending Confirmation' },
    { value: 'CA', label: 'Cancelled' },
    { value: 'FN', label: 'Finished' },
    { value: 'RJ', label: 'Rejected' }
  ];

  const [paginationInfo, setPaginationInfo] = useState({
    page_number: 1,
    page_size: 10,
    page_total: 1,
    results_total: 0
  });

  const navigate = useNavigate()
  const [drawerOpen, setDrawerOpen] = useState(false)

  function getBookingsInfo() {
    setLoading(true);
    getBookings(filters).then(r => {
      setBookings(r.bookings)
      setPaginationInfo({
        page_number: parseInt(r.page_number),
        page_size: parseInt(r.page_size),
        page_total: parseInt(r.page_total),
        results_total: parseInt(r.results_total)
      });
      setLoading(false);
    })
      .catch(() => {
        setLoading(false);
      })
  }

  function clearFilters() {
    setFilters({
      status: 'AL',
      venue: '',
      code: '',
      date: '',
      order_by: 'planned_start_day',
      order_dir: 'desc',
      page_size: 10,
      page_number: 1
    });
  }

  const handleBookingAction = (slug, action, updatedBooking = null) => {
    switch (action) {
      case 'accept':
        // Handle accept logic
        break;
      case 'reject':
        // Handle reject logic
        break;
      case 'update':
        // Update the booking in state
        if (updatedBooking) {
          setBookings(prevBookings => prevBookings.map(b =>
            b.slug === slug ? updatedBooking : b
          ));          
          setSelectedBooking(updatedBooking);
        }
        break;
      // Other cases...
    }
  };


  function navigateBooking(booking) {
    //navigate(`/bookings/${booking?.slug}`);
    setSelectedBooking(booking)
    setOpenDetails(true)
    //window.location.href = '/login'
  }

  function navigateSearch() {
    navigate(`/booking-find`);
  }

  function navigateVenue(slug) {
    navigate(`/venue/${slug}`);
  }


  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
      page_number: 1
    });
  };

  const handlePageChange = (pageNumber) => {
    setFilters({
      ...filters,
      page_number: pageNumber
    });
  };

  const handleSortChange = (column) => {
    const newOrderDir = filters.order_by === column && filters.order_dir === 'asc' ? 'desc' : 'asc';
    setFilters({
      ...filters,
      order_by: column,
      order_dir: newOrderDir,
      page_number: 1 // Reset page number when sorting changes
    });
  };

  useEffect(() => {
    getBookingsInfo(true)

  }, [filters])


  return (
    <Container>
      {/* Header Section */}
      <BookingsHeader>
        <Box>
          <Typography variant="h5">
            <EventNoteIcon /> {/* or CalendarTodayIcon */}
            Your Workspace Schedule
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Manage your upcoming bookings
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={navigateSearch}
          sx={{
            borderRadius: '20px',
            textTransform: 'none',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            '& .MuiButton-startIcon': {
              [theme.breakpoints.down('sm')]: {
                margin: 0  // Remove icon margin on mobile
              }
            },
            [theme.breakpoints.down('sm')]: {
              minWidth: 'unset',  // Allow button to be smaller
              px: 2  // Reduce horizontal padding
            }
          }}
        >
          {isMobile ? 'Book' : 'Book New Space'}  {/* Shorter text on mobile */}
        </Button>
      </BookingsHeader>

      {/* Filters Section */}
      <Box sx={{
        bgcolor: 'background.paper',
        borderRadius: 1,
        p: 2,
        mb: 3,
        mx: 3,
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
      }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }}>
          {(filters.venue || filters.status !== 'AL' || filters.code || filters.date) && (
            <Button
              size="small"
              onClick={clearFilters}
              startIcon={<CloseIcon />}
              sx={{ ml: 'auto' }}
            >
              Clear all
            </Button>
          )}
        </Box>

        {/* Desktop Filters */}
        <Grid container spacing={2} sx={{ display: { xs: 'none', md: 'flex' } }}>
          <Grid item xs={2.4}>
            <TextField
              label={t('Venue')}
              name="venue"
              value={filters.venue}
              onChange={handleFilterChange}
              variant="outlined"
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              select
              label={t('Status')}
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
              variant="outlined"
              fullWidth
              size="small"
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {t(option.label)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              label={t('Code')}
              name="code"
              value={filters.code}
              onChange={handleFilterChange}
              variant="outlined"
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              label={t('Date')}
              name="date"
              type="date"
              value={filters.date}
              onChange={handleFilterChange}
              variant="outlined"
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={2.4}>
            <TextField
              select
              label={t('Sort By')}
              name="order_by"
              value={filters.order_by}
              onChange={handleFilterChange}
              variant="outlined"
              fullWidth
              size="small"
            >
              <MenuItem value="planned_start_day">{t('Day')}</MenuItem>
              <MenuItem value="venue__name">{t('Venue')}</MenuItem>
              <MenuItem value="status">{t('Status')}</MenuItem>
              <MenuItem value="code">{t('Code')}</MenuItem>
            </TextField>
          </Grid>
        </Grid>

        {/* Mobile Filter Button */}
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => setDrawerOpen(true)}
            startIcon={<FilterListIcon />}
          >
            {t('Show Filters')}
          </Button>
        </Box>
      </Box>

      {/* Bookings List */}
      <BookingList
        bookings={bookings}
        filters={filters}
        handleSortChange={handleSortChange}
        handlePageChange={handlePageChange}
        navigateBooking={navigateBooking}
        statusMapping={statusMapping}
        paginationInfo={paginationInfo}
        t={t}
        resultLimit={filters.page_size}
        loadingBookings={loading}
      />


      {/* Filter Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: 320,
            p: 2,
            boxSizing: 'border-box'
          }
        }}
      >
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}>
          {/* Drawer Header */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
            pb: 1,
            borderBottom: 1,
            borderColor: 'divider'
          }}>
            <Typography variant="h6">Filters</Typography>
            <IconButton onClick={() => setDrawerOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Filter Fields */}
          <Box sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            overflowY: 'auto'
          }}>
            <TextField
              label={t('Venue')}
              name="venue"
              value={filters.venue}
              onChange={handleFilterChange}
              variant="outlined"
              fullWidth
              size="small"
            />

            <TextField
              select
              label={t('Status')}
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
              variant="outlined"
              fullWidth
              size="small"
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {t(option.label)}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              label={t('Code')}
              name="code"
              value={filters.code}
              onChange={handleFilterChange}
              variant="outlined"
              fullWidth
              size="small"
            />

            <TextField
              label={t('Date')}
              name="date"
              type="date"
              value={filters.date}
              onChange={handleFilterChange}
              variant="outlined"
              fullWidth
              size="small"
              InputLabelProps={{
                shrink: true
              }}
            />

            <TextField
              select
              label={t('Sort By')}
              name="order_by"
              value={filters.order_by}
              onChange={handleFilterChange}
              variant="outlined"
              fullWidth
              size="small"
            >
              <MenuItem value="planned_start_day">{t('Day')}</MenuItem>
              <MenuItem value="venue__name">{t('Venue')}</MenuItem>
              <MenuItem value="status">{t('Status')}</MenuItem>
              <MenuItem value="code">{t('Code')}</MenuItem>
            </TextField>
          </Box>

          {/* Action Buttons */}
          <Box sx={{
            mt: 3,
            pt: 2,
            borderTop: 1,
            borderColor: 'divider',
            display: 'flex',
            gap: 1
          }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => {
                clearFilters();
                setDrawerOpen(false);
              }}
            >
              Clear
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={() => setDrawerOpen(false)}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Drawer>

      <Modal
        open={openDetails}
        onClose={() => setOpenDetails(false)}
        aria-labelledby="confirmation-modal-title"
        aria-describedby="confirmation-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ModalContent>
          <BookingDetail booking={selectedBooking} view="tenant" navigateVenue={navigateVenue} handleBookingAction={handleBookingAction}/>

        </ModalContent>
      </Modal>
      {/* List of communities */}
    </Container>
  )
}

BookingHome.propTypes = {}

export default BookingHome
